import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database.types';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing Supabase env vars. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in apps/neurax-portal/.env.local'
  );
}

const STORAGE_KEY = 'neurax-portal-auth';

// One-time migration: carry over an existing session from the legacy wolf-portal-auth
// key so users stay signed in across the rename. Safe to remove after a grace period.
if (typeof window !== 'undefined') {
  try {
    const legacy = window.localStorage.getItem('wolf-portal-auth');
    if (legacy && !window.localStorage.getItem(STORAGE_KEY)) {
      window.localStorage.setItem(STORAGE_KEY, legacy);
      window.localStorage.removeItem('wolf-portal-auth');
    }
  } catch {
    // localStorage unavailable — skip silently
  }
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    storage: window.localStorage,
    storageKey: STORAGE_KEY,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  global: {
    headers: { 'x-client-info': 'neurax-portal' },
  },
  db: { schema: 'public' },
});

export type SupabaseClient = typeof supabase;
